export default __webpack_public_path__ + "static/media/Shape.0475d8d2.svg";